import { render, staticRenderFns } from "./Masters2025.vue?vue&type=template&id=3f3e8d80&scoped=true"
import script from "./Masters2025.vue?vue&type=script&lang=js"
export * from "./Masters2025.vue?vue&type=script&lang=js"
import style0 from "./Masters2025.vue?vue&type=style&index=0&id=3f3e8d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e8d80",
  null
  
)

export default component.exports